/* eslint-disable camelcase */
import { toUpper } from 'lodash/fp';
import moment from 'moment';

import { DEFAULT_DATE_FORMAT, FIELD_NAMES } from './constants';
import { FieldDataParams, FormValues } from './types';
import { WidgetData } from '../../../../components/embedded-widget/types';
import AutoCompleteInput from './components/auto-complete-input';
import constants from '../../../../ahm-constants';
import DatePicker from './components/date-picker';
import DestinationSuggestions from './components/destination-suggestions';
import TravellerDetails from './components/traveller-details';

const formatDate = (date: string) => moment(date, constants.DATE_FORMAT.STANDARD).format(toUpper(DEFAULT_DATE_FORMAT));

const getTravelWidgetData =
  <T extends FormValues>({ amountOfTravellers = 0, countries }: FieldDataParams) =>
  (values: T): WidgetData[] => [
    {
      icon: 'search',
      inputComponent: AutoCompleteInput,
      inputData: countries,
      modalComponent: DestinationSuggestions,
      name: FIELD_NAMES.WHERE,
      placeholder: 'Search destinations',
    },
    {
      displayValue: {
        getLabel: () =>
          `${values.departureDate ? formatDate(values.departureDate) : DEFAULT_DATE_FORMAT} - ${
            values.returnDate ? formatDate(values.returnDate) : DEFAULT_DATE_FORMAT
          }`,
        isActive: !!values.departureDate || !!values.returnDate,
      },
      icon: 'calendar',
      modalComponent: DatePicker,
      name: FIELD_NAMES.WHEN,
    },
    {
      displayValue: {
        getLabel: () => {
          const totalNumberOfTravellers = values.travelerAge_1 ? amountOfTravellers + 1 : 0;
          return totalNumberOfTravellers
            ? `${totalNumberOfTravellers} traveller${totalNumberOfTravellers > 1 ? 's' : ''}`
            : 'Traveller details';
        },
        isActive: !!values.travelerAge_1 || !!amountOfTravellers,
      },
      hasButton: true,
      icon: 'user',
      modalComponent: TravellerDetails,
      name: FIELD_NAMES.WHO,
    },
  ];

export default getTravelWidgetData;
